import './src/styles/global.css';
import wrapWithProvider from './redux-provider';
export const wrapRootElement = wrapWithProvider;
